module.exports = __webpack_public_path__ + "c99527303dd74a2f370d6952e4f68d08.svg";